import {Component, ElementRef, forwardRef, Input, ViewChild} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CommonModule} from '@angular/common';

@Component({
    imports: [CommonModule, FormsModule],
    selector: 'app-password-input',
    templateUrl: './password-input.component.html',
    styleUrls: ['./password-input.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => PasswordInputComponent),
        }
    ]
})
export class PasswordInputComponent implements ControlValueAccessor {
  public disabled = false;
  @Input() required = false;
  @Input() autocomplete = 'off';
  @Input() label = false;
  @Input() errorMessage = false;
  @Input() controlname = '';
  @Input() isHidden = true;
  @Input() isInline = true;
  @Input() showLabel = true;
  public value: string;
  @ViewChild('passwordInputElement', {static: false}) passwordInputElement: ElementRef<HTMLInputElement>;

  constructor() {
  }

  public onTouched() {
  }

  public onChange(value: string) {
  }

  writeValue(obj: any): void {
    this.value = obj;
    this.onChange(this.value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


}
